'use client';

import React from 'react';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import { useUserInfo } from '@/provider/UserInfoProvider';
import { Loader2 } from 'lucide-react';
import { usePathname } from 'next/navigation';
import Share from './Share';
import { useDeviceType } from '@/ueshook/useDeviceType';
import useInvite from '../../invite/hooks/useInvite';

const Promote = ({ isModal = false }: { isModal?: boolean }) => {
  const { handleInvite, inviteIsPending, inviteTimeLeft } = useInvite();
  const deviceType = useDeviceType();
  const pathname = usePathname();
  const { userIdentity } = useUserInfo();
  const isLoginUser = userIdentity === 3;

  return (
    <div className='@container'>
      <div
        className={`mx-auto mb-[1.875rem] ${pathname.includes('watermark-removal') ? 'mt-0' : 'mt-6'} max-w-7xl rounded-lg bg-[#f5f5f5] py-3 ${pathname.includes('watermark-removal') ? 'px-0' : 'px-5'} ${isLoginUser && pathname.includes('watermark-removal') ? '@md:px-6' : '@md:px-10'}`}
      >
        <div className='flex flex-col items-center justify-between @3xl:flex-row'>
          <div className='w-full'>
            <h2 className='mb-[0.6125rem] text-2xl font-semibold text-gray-800'>
              Invite friends {deviceType === 'mobile' ? <br /> : '&'} Get up to
              25% off
            </h2>
            <div className='mb-[1.5625rem] text-base text-gray-800 @container'>
              <p className='tracking-tight @[21.875rem]:tracking-normal'>
                🎁 Invite 1 friend → Get a 10% off Promo Code
              </p>
              <p className='tracking-tighter @[21.875rem]:tracking-normal'>
                🎁 Invite 3 friends → Get a 25% off Promo Code
              </p>
              <p className='tracking-tight @[21.875rem]:tracking-normal'>
                🎁 Your friend gets 3 extra credits!
              </p>
            </div>
            <div className='flex items-center justify-between'>
              <Button
                className={`rounded-[0.375rem] ${!isModal && deviceType === 'mobile' ? 'h-6 rounded-none border-b border-gray-800 bg-transparent p-0 text-[1.125rem] text-black hover:bg-transparent' : 'bg-gray-800 text-base text-stone-50'} font-medium ${inviteIsPending || inviteTimeLeft > 0 ? 'pointer-events-none' : 'pointer-events-auto'}`}
                onClick={handleInvite}
              >
                {inviteIsPending ? (
                  <Loader2 className='mr-1 animate-spin' size={16} />
                ) : (
                  ''
                )}
                {inviteTimeLeft > 0 ? 'Link copied!' : 'Copy your link'}
              </Button>
              {!isModal && deviceType === 'mobile' && <Share />}
            </div>
          </div>
          <Image
            src='https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/d39a54b2-bc4d-4ec3-0605-87561ace5c00/public'
            alt='people'
            className='mt-7 hidden h-[14.625rem] w-[21.875rem] rounded-lg @3xl:block md:mt-0'
            width={350}
            height={234}
          />
        </div>
      </div>
    </div>
  );
};

export default Promote;
